import { useEffect, useState } from "react";
import { getEmployeeRoles, getUsers } from "../api/users";
import type {
  DictionaryItem,
  RolesDictionaryResponse,
  User,
} from "../types/users.types";
import { UsersHeader } from "../components/UsersHeader/UsersHeader";
import { UsersTable } from "../components/UsersTable/UsersTable";
import { UsersModal } from "../components/UsersModal/UsersModal";
import { UsersFilter } from "../components/UsersFilters/UsersFilter";
import { getFilters, type SystemDictionary } from "@/shared/api/filters";
import { toast } from "sonner";

export interface ModalType {
  modalType: "create" | "edit" | "delete";
}

// types
export interface UsersFiltersState {
  role: string;
  status: string;
  keyword: string;
}

export function UsersPage() {
  const [users, setUsers] = useState<User[]>([]);
  const [user, setUser] = useState<User>();
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [modalType, setModalType] = useState<ModalType["modalType"]>("create");
  const [roles, setRoles] = useState<DictionaryItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [dictionary, setDictionary] = useState<SystemDictionary | undefined>();
  const [filters, setFilters] = useState<UsersFiltersState>({
    role: "",
    status: "",
    keyword: "",
  });

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const res = await getUsers(filters);
        const dictionary = await getFilters();
        setUsers(res);
        setDictionary(dictionary);
        setRoles(dictionary.employee_roles);
      } catch (e) {
        const message = e instanceof Error ? e.message : "Ошибка";
        toast.error(message);
        console.error(e);
        setError("Не удалось загрузить пользователей");
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, [filters, isUserModalOpen]);

  const handleOpenModal = (modalType: ModalType["modalType"], user?: User) => {
    setIsUserModalOpen(true);
    setModalType(modalType);
    setUser(user);
  };
  return (
    <div className="max-w-[1400px] mx-auto">
      <UsersHeader onClick={handleOpenModal} />
      <UsersFilter
        dictionary={dictionary}
        setFilters={setFilters}
        filters={filters}
      />
      <UsersTable users={users} onClick={handleOpenModal} />

      <UsersModal
        user={user}
        open={isUserModalOpen}
        onOpenChange={setIsUserModalOpen}
        modalType={modalType}
        roles={roles}
      />
    </div>
  );
}
